import React, { Component } from 'react';
import { Navbar, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import HeaderLinks from './HeaderLinks.jsx';

import logo from '../../assets/img/TransflesaLogo.png';
class Header extends Component {
	constructor(props) {
		super(props);
		this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
		this.state = {
			sidebarExists: false
		};
	}
	mobileSidebarToggle(e) {
		if (this.state.sidebarExists === false) {
			this.setState({
				sidebarExists: true
			});
		}
		e.preventDefault();
		document.documentElement.classList.toggle('nav-open');
		var node = document.createElement('div');
		node.id = 'bodyClick';
		node.onclick = function() {
			this.parentElement.removeChild(this);
			document.documentElement.classList.toggle('nav-open');
		};
		document.body.appendChild(node);
	}

	render() {
		return (
			<Navbar fluid>
				<Navbar.Header>
					<Row>
						<div className="no-visible">
							<i
								className={this.props.sidebarShow !== false ? 'pe-7s-menu' : 'pe-7s-keypad'}
								style={{ fontSize: '35px', float: 'left', color: '#827E7E', borderRadius: '50%' }}
								onClick={() => this.props.clickHandler()}
							/>
						</div>
						<Navbar.Toggle onClick={this.mobileSidebarToggle} style={{ float: 'left' }} />
					</Row>
				</Navbar.Header>
				<Navbar.Collapse>
					<HeaderLinks {...this.props} />
				</Navbar.Collapse>
				<div style={{ textAlign: 'center', marginTop: '-50px' }}>
					<img src={logo} alt="logo_image" width="15%" height="auto" />&nbsp;&nbsp;
				</div>
			</Navbar>
		);
	}
}

Header.propTypes = {};

Header.contextTypes = {};

function mapStateToProps(state) {
	return {};
}

export default connect(mapStateToProps)(Header);
